export const en = {
    campaign_context_enable_cpc_hold: 'Maintain average CPC lower than average search CPC',
    campaign_context_limit:
        'Maintain expenditure within {oldLimitPercent} {newLimitPercent} of total campaign expenditures',
    campaign_context_limit_not_changed: 'Maintain expenditure within {limitPercent}% of total campaign expenditures'
};
